import React from 'react';

export const SMARTFormContext = React.createContext();
export const SMARTSectionContext = React.createContext();